import axiosInstance from './axiosInstance';

const categoryService = {
  list:    (params = {}) => axiosInstance.get('/admin/categories', { params }),
  listAll: (type)        => axiosInstance.get('/admin/categories/all', { params: type ? { type } : {} }),
  getById: (id)          => axiosInstance.get(`/admin/categories/${id}`),
  create:  (data)        => axiosInstance.post('/admin/categories', data),
  update:  (id, data)    => axiosInstance.put(`/admin/categories/${id}`, data),
  remove:  (id)          => axiosInstance.delete(`/admin/categories/${id}`),
};

export default categoryService;
